// extracted by mini-css-extract-plugin
export default {"container":"Sidebar_container__2SbPd","sidebar":"Sidebar_sidebar__zfhso","listTitle":"Sidebar_listTitle__Gmwnw","dataList":"Sidebar_dataList__Yw+vM"};